import React from 'react';
import PropTypes from 'prop-types';
import { DiscussionEmbed } from 'disqus-react';
import { FeedCard, GoogleDFP } from '@surfline/quiver-react';
import StickyAdUnit from "../StickyAdUnit";
import articlePropType from '../../propTypes/article';
import loadAdConfig from '../../utils/adConfig';


const EditorialArticleFooter = ({ article, isPremium, qaFlag, doTrackEvent, isMobile }) => {
  const {
    permalink,
    createdAt,
    displayOptions: { hideAds, hideComments },
    sponsoredArticle: { dfpKeyword },
    relatedPosts,
    premium,
  } = article;
  /*
    Legacy articles used peramlink for disqus id and must use same id to maintain comment history.
    Using id is preferable for new articles to prevent losing comments on title/permalink change.
  */
  const disqusIdentifier = new Date(createdAt) < new Date('2019-04-29 00:00:00')
    ? permalink
    : article.id;
  const disqusConfig = {
    url: permalink,
    identifier: disqusIdentifier,
    title: article.content.displayTitle || article.content.title,
  };
  return (
    <div className="sl-editorial-article-footer" id="sl-editorial-article-footer">
      <div className="sl-editorial-article-footer__content">
        <div className="sl-editorial-article-footer__content__left">
          {!hideComments && !(premium.premium && !isPremium) ? (
            <div className="sl-editorial-article-footer__disqus">
              <DiscussionEmbed shortname="surfline-comments" config={disqusConfig} />
            </div>
          )
            : null}
          {isMobile && (dfpKeyword || (!hideAds && !isPremium)) ? (
            <div className="sl-editorial-article-footer__ad--mid">
              <GoogleDFP
                adConfig={loadAdConfig(
                  'editFooter', [['qaFlag', qaFlag], ['contentKeyword', dfpKeyword]],
                )}
              />
            </div>
          )
            : null}
          <h5 className="sl-editorial-article-footer__title">Related Content</h5>
          <div className="sl_editorial-article-footer__related-articles">
            {relatedPosts.map((relatedArticle) => {
              const selectTag = relatedArticle.series[0] || relatedArticle.categories[0];
              return (
                <FeedCard
                  isPremium={relatedArticle.premium}
                  key={relatedArticle.title}
                  category={selectTag}
                  title={relatedArticle.title}
                  subtitle={relatedArticle.subtitle}
                  onClickLink={() => doTrackEvent('Clicked Link', {
                    linkURL: relatedArticle.permalink,
                    category: 'editorial',
                    linkLocation: 'editorial related article',
                    linkName: relatedArticle.title,
                    articleId: relatedArticle.id,
                  })}
                  onClickTag={() => doTrackEvent('Clicked Link', {
                    linkURL: selectTag.url,
                    category: 'editorial',
                    linkLocation: 'editorial related article tag',
                    linkName: selectTag.name,
                  })}
                  permalink={relatedArticle.permalink}
                  createdAt={relatedArticle.createdAt}
                  imageUrl={relatedArticle.media ? relatedArticle.media.feed2x : null}
                />
              );
            })}
          </div>
        </div>
        {!isMobile && (dfpKeyword || (!hideAds && !isPremium)) ? (
          <div className="sl-editorial-article-footer__content__right">
            <StickyAdUnit
              isDesktop
              qaFlag={qaFlag}
              adUnit="editFooter"
              bottomBoundary=".sl-editorial-article-footer__content__right"
              dfpKeyword={dfpKeyword}
              className="sl-editorial-article-footer__ad__right"
            />
          </div>
        )
          : null}
      </div>
      {!hideAds && !isPremium ? (
        <div className="sl-editorial-article-footer__ad--bottom">
          <GoogleDFP adConfig={loadAdConfig('editFooterBottom', [['qaFlag', qaFlag]])} />
        </div>
      )
        : null}
    </div>
  );
};

EditorialArticleFooter.propTypes = {
  article: articlePropType.isRequired,
  doTrackEvent: PropTypes.func.isRequired,
  isPremium: PropTypes.bool,
  isMobile: PropTypes.bool,
  qaFlag: PropTypes.string,
};

EditorialArticleFooter.defaultProps = {
  isPremium: false,
  isMobile: false,
  qaFlag: null,
};

export default EditorialArticleFooter;
